<h1 class="setting-title" i18n="@@settings_editAccount_title">Account</h1>
<h3 class="mb-3 subtitle-setting" i18n="@@settings_editAccount_emailSubtitle">
  Modify your email
</h3>
<div class="section-email">
  <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmail()">
    <div class="form-group">
      <label
        class="lbl-patient fw-medium"
        for="email"
        i18n="@@settings_editAccount_formEmailLabel"
      >
        Email*
      </label>
      <input
        class="form-control"
        type="email"
        name="email"
        id="email"
        formControlName="email"
      />
      <ng-container
        *ngIf="
          emailForm.get('email').invalid &&
          (emailForm.get('email').dirty || emailForm.get('email').touched)
        "
      >
        <small
          class="text-danger"
          *ngIf="emailForm.get('email').errors['required']"
          i18n="@@settings_editAccount_formEmailRequired"
        >
          email is required
        </small>
      </ng-container>
    </div>
    <button
      type="submit"
      [disabled]="
        !emailForm.valid || emailForm.get('email').value === profileEmail
      "
      class="btn btn-primary mt-5 w-75"
    >
      <span i18n="@@settings_editAccount_saveButton">Valider</span>
      <span class="icon"
        ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
      /></span>
    </button>
  </form>
</div>
<h3
  class="mb-3 subtitle-setting"
  i18n="@@settings_editAccount_passwordSubtitle"
>
  Change your password
</h3>
<app-email from="account" (createdPassword)="setPassword($event)"></app-email>
